export default __webpack_public_path__ + "4bfc948a9565e0d9643130c683846b40.png";